module.exports = __webpack_public_path__ + "static/tucc-logo.f15636fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners/tucc-logo.svg
// module id = 187
// module chunks = 35783957827783 255223432971881